var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTr2AbtSmallCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 80,
    viewBox: "0 0 69 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2507_8424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 32.0898L34.5 24.1796L48.1216 32.0898L34.5 40.0001L20.8784 32.0898Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 32.0898L34.5 24.1796L48.1216 32.0898L34.5 40.0001L20.8784 32.0898Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 32.0898L34.5 40.0001V55.8207L20.8784 47.9104V32.0898Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 32.0898L34.5 40.0001V55.8207L20.8784 47.9104V32.0898Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1216 32.0898V47.9104L34.5 55.8207V40.0001L48.1216 32.0898Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1216 32.0898V47.9104L34.5 55.8207V40.0001L48.1216 32.0898Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3105 43.9553L54.9322 36.045L68.5538 43.9553L54.9322 51.8655L41.3105 43.9553Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3105 43.9553L54.9322 36.045L68.5538 43.9553L54.9322 51.8655L41.3105 43.9553Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3105 43.9552L54.9322 51.8655V67.6861L41.3105 59.7758V43.9552Z",
    fill: "#092256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3105 43.9552L54.9322 51.8655V67.6861L41.3105 59.7758V43.9552Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5537 43.9552V59.7758L54.9321 67.6861V51.8655L68.5537 43.9552Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5537 43.9552V59.7758L54.9321 67.6861V51.8655L68.5537 43.9552Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.445801 43.9553L14.0673 36.045L27.6889 43.9553L14.0673 51.8655L0.445801 43.9553Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.445801 43.9553L14.0673 36.045L27.6889 43.9553L14.0673 51.8655L0.445801 43.9553Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.445801 43.9552L14.0673 51.8655V67.6861L0.445801 59.7758V43.9552Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.445801 43.9552L14.0673 51.8655V67.6861L0.445801 59.7758V43.9552Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.689 43.9552V59.7758L14.0674 67.6861V51.8655L27.689 43.9552Z",
    fill: "#092256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.689 43.9552V59.7758L14.0674 67.6861V51.8655L27.689 43.9552Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 55.8207L34.5 47.9104L48.1216 55.8207L34.5 63.731L20.8784 55.8207Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 55.8207L34.5 47.9104L48.1216 55.8207L34.5 63.731L20.8784 55.8207Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 55.8207L34.5 63.731V79.5515L20.8784 71.6412V55.8207Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 55.8207L34.5 63.731V79.5515L20.8784 71.6412V55.8207Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1216 55.8207V71.6412L34.5 79.5515V63.731L48.1216 55.8207Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1216 55.8207V71.6412L34.5 79.5515V63.731L48.1216 55.8207Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 8.35906L34.5 0.448775L48.1216 8.35906L34.5 16.2693L20.8784 8.35906Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 8.35906L34.5 0.448775L48.1216 8.35906L34.5 16.2693L20.8784 8.35906Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 8.35907L34.5 16.2694V32.0898L20.8784 24.1796V8.35907Z",
    fill: "#092256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 8.35907L34.5 16.2694V32.0898L20.8784 24.1796V8.35907Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1216 8.35907V24.1796L34.5 32.0898V16.2694L48.1216 8.35907Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1216 8.35907V24.1796L34.5 32.0898V16.2694L48.1216 8.35907Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3105 20.2245L54.9322 12.3142L68.5538 20.2245L54.9322 28.1347L41.3105 20.2245Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3105 20.2245L54.9322 12.3142L68.5538 20.2245L54.9322 28.1347L41.3105 20.2245Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3105 20.2245L54.9322 28.1347V43.9553L41.3105 36.045V20.2245Z",
    fill: "#092256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3105 20.2245L54.9322 28.1347V43.9553L41.3105 36.045V20.2245Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5537 20.2245V36.045L54.9321 43.9553V28.1347L68.5537 20.2245Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5537 20.2245V36.045L54.9321 43.9553V28.1347L68.5537 20.2245Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.445801 20.2245L14.0673 12.3142L27.6889 20.2245L14.0673 28.1347L0.445801 20.2245Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.445801 20.2245L14.0673 12.3142L27.6889 20.2245L14.0673 28.1347L0.445801 20.2245Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.445801 20.2245L14.0673 28.1347V43.9553L0.445801 36.045V20.2245Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.445801 20.2245L14.0673 28.1347V43.9553L0.445801 36.045V20.2245Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.689 20.2245V36.045L14.0674 43.9553V28.1347L27.689 20.2245Z",
    fill: "#092256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.689 20.2245V36.045L14.0674 43.9553V28.1347L27.689 20.2245Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 32.0898L34.5 24.1796L48.1216 32.0898L34.5 40.0001L20.8784 32.0898Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 32.0898L34.5 24.1796L48.1216 32.0898L34.5 40.0001L20.8784 32.0898Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 32.0898L34.5 40.0001V55.8207L20.8784 47.9104V32.0898Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8784 32.0898L34.5 40.0001V55.8207L20.8784 47.9104V32.0898Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1216 32.0898V47.9104L34.5 55.8207V40.0001L48.1216 32.0898Z",
    fill: "#FEE2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1216 32.0898V47.9104L34.5 55.8207V40.0001L48.1216 32.0898Z",
    stroke: "#092256",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2507_8424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr2AbtSmallCube);
export default __webpack_public_path__ + "static/media/tr2-abt-small-cube.a841850c2d8083de839830bff7b72cf8.svg";
export { ForwardRef as ReactComponent };